import { AnalyticIdentifier } from '@common/neo.tax';
import { getSelectPopoverId } from '@ui-components/neo.tax';
import { useMemo } from 'react';

// A list of element ids that should not be locked when the page is locked
export const useUnlockedElementIds = (): Set<string> =>
  useMemo(
    () =>
      new Set([
        `${AnalyticIdentifier.PROFILE_MENU}`,
        `${AnalyticIdentifier.HEADER_LOGOUT}`,
        `${AnalyticIdentifier.HEADER_PROFILE}`,
        `${AnalyticIdentifier.FISCAL_PERIOD_MODAL_YEAR_SELECT}`,
        getSelectPopoverId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_YEAR_SELECT),
        `${AnalyticIdentifier.FISCAL_PERIOD_MODAL_PERIOD_SELECT}`,
        getSelectPopoverId(AnalyticIdentifier.FISCAL_PERIOD_MODAL_PERIOD_SELECT),
        getSelectPopoverId(AnalyticIdentifier.RTC_CREATE_COMPANY_FISCAL_YEAR_END_MONTH),
        `${AnalyticIdentifier.RTC_INVITE_MEMBER_EMAIL_INPUT}-new`,
      ]),
    [],
  );
